import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import Header from "./components/Header/Header";

//pages...
import HomePage from "./pages/homepage/HomePage";
import AboutPage from "./pages/about/AboutPage";
import ContactPage from "./pages/contact/ContactPage";
import ProductsPage from "./pages/products/ProductsPage";
import Footer from "./components/Footer/Footer";
import UnderConstruction from "./pages/UnderConstruction/UnderConstruction";
import AfterSalesServicePage from "./pages/AfterSalesServicePage/AfterSalesServicePage";
import MehdiGhaderi from "./pages/examinations/MehdiGhaderi";
import RezaHeydari from "./pages/examinations/RezaHeydari";
import MohammadjavadFallahiDarooni from "./pages/examinations/MohammadjavadFallahiDarooni";
import SaeedMousivand from "./pages/examinations/SaeedMousivand";
import MohammadaliRezaeeKardo from "./pages/examinations/MohammadaliRezaeeKardo";
import AliGhafouri from "./pages/examinations/AliGhafouri";

function App() {
  const { pathname } = useLocation();

  return (
    <div>
       {pathname.includes("-") ? (
        <>
          <Routes>
            <Route
              path="/mehdi-ghaderi"
              element={<MehdiGhaderi />}
            />

            <Route
              path="/reza-heydari"
              element={<RezaHeydari />}
            />

            <Route
              path="/mohammadjavad-fallahi-darooni"
              element={<MohammadjavadFallahiDarooni />}
            />

            <Route
              path="/saeed-mousivand"
              element={<SaeedMousivand />}
            />

            <Route
              path="/mohammadali-rezaee-kardo"
              element={<MohammadaliRezaeeKardo />}
            />
            <Route
              path="/ali-ghafouri"
              element={<AliGhafouri />}
            />
          </Routes>
        </>
      ) : (
        <>
      <Header />
      <Routes>
        <Route path="/home" element={<Navigate replace to="/" />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/news" element={<UnderConstruction />} />
        <Route path="/aftersalesservice" element={<AfterSalesServicePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="faq" element={<UnderConstruction />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
      <Footer />
      </>)}
    </div>
  );
}

export default App;
